export enum FEATURE_FLAGS {
  ENABLE_LANGUES_DEMO_SIMPLE_CARDS = "mw-langues-demo-simple-cards",
  ENABLE_VOICES_SLIDER_NO_AUTOSCROLL = "mw-voices-slider-no-autoscroll",
  ENABLE_VOICE_CHANGER_SOFT_NUDGE_V2 = "mw-voice-changer-soft-nudge-v2",
  ENABLE_VOICE_CLONING_SOFT_NUDGE_V2 = "mw-voice-cloning-soft-nudge-v2",
  ENABLE_ELVENLABS_PAGE = "mw-elvenlabs-page",
  ENABLE_HERO_AGENT_VARIANTS = "mw-hero-agent-variants",
  ENABLE_FLOATING_AGENT_REDESIGN = "mw-floating-agent-redesign",
  ENABLE_SESSION_RECORDING = "mw-session-recording",
  ENABLE_DUBBING_V2_TRANSLATE_PAGES_COPY = "mw-dubbing-v2-translate-pages-copy",
  ENABLE_AGENT_TEMPLATE_DEFAULT_PREVIEW = "mw-agent-template-default-preview",
  ENABLE_SFX_DOWNLOAD_EDIT_MENU = "mw-sfx-download-edit-menu",
  ENABLE_VOICE_LIBRARY_SINGLE_CTA = "mw-voice-library-single-cta",
  ENABLE_VOICE_CHANGER_SINGLE_CTA = "mw-voice-changer-single-cta",
  ENABLE_STT_SINGLE_CTA = "mw-stt-single-cta",
  ENABLE_LANGUAGES_SINGLE_CTA = "mw-languages-single-cta",
  ENABLE_EXTERNAL_MODEL_SINGLE_CTA = "mw-external-model-single-cta",
}
